var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaddoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9496 15.4433L13.5047 10.998L9.05981 15.4433",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5051 10.998V20.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8279 18.1002C23.9117 17.5093 24.7679 16.5743 25.2613 15.4427C25.7547 14.3111 25.8573 13.0474 25.5528 11.851C25.2483 10.6547 24.5541 9.59378 23.5798 8.8358C22.6054 8.07781 21.4065 7.66591 20.172 7.6651H18.7719C18.4356 6.36403 17.8087 5.15614 16.9383 4.13225C16.068 3.10836 14.9769 2.29511 13.7471 1.75363C12.5172 1.21216 11.1807 0.95655 9.83783 1.00603C8.495 1.05551 7.18085 1.40879 5.99419 2.0393C4.80753 2.66982 3.77924 3.56116 2.98662 4.64633C2.194 5.73149 1.65767 6.98224 1.41797 8.30453C1.17827 9.62683 1.24143 10.9863 1.60269 12.2806C1.96396 13.575 2.61394 14.7706 3.50375 15.7776",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9496 15.4433L13.5047 10.998L9.05981 15.4433",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaddoc);
export default __webpack_public_path__ + "static/media/uploaddoc.ea67bd3314a20341516b58e980651487.svg";
export { ForwardRef as ReactComponent };